import { DeviceInfo } from "../../device/DeviceInfoContext";

export const PlaylistLivePositionEventName = "playlistLivePosition";

export interface PlaylistLivePositionPayload extends DeviceInfo {
  playlistIdentifier: string;
  timestamp: number;
  selectedPlaylistItemInMemoryId: number | undefined;
  viewMode: "lyrics" | "songsheet";
  currentLyricsPosition: number | undefined;
  /** page within the selected item: its songsheet image in songsheet mode, always 0 in lyrics mode */
  pageInItem: number | undefined;
}
